// extracted by mini-css-extract-plugin
export default {"region":"jwZpV","label":"kBkY6","icon":"F9vho"};